import styles from '../kyc-intelligence.module.css';

function Cover() {

    return (<>
        <div className={styles['report-cover']}>
            <div className={styles['report-header']}>
                <img src="../images/alverezandmarsal-logo.png" alt="logo-dark" />
                <p>
                    &nbsp;
                    <span style={{fontSize:'20px'}}>Website : alvarezandmarsal.com</span>
                </p>
            </div>
            <div className={styles['report-cover-title']}>
                <h1><img src="../images/alverezandmarsal-check.svg" alt="check" /> A&M INTELLIGENCE 360</h1>
                <h2>CORPORATE <br/> INTELLIGENCE <span>REPORT</span></h2>
            </div>
        </div>
    </>);
}

export default Cover;